<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Thiết lập tài khoản</h4>
          </template>
          <template v-slot:body>
            <b-button variant="secondary" class="mb-4 mt-2 mr-2" @click="$router.push({ name: 'manage.account' })">
              <i class="las la-list-alt"/>
              DS Tài khoản
            </b-button>
            <b-button variant="primary" class="mb-4 mt-2 mr-2">
              <i class="las la-cogs"/>
              Thiết lập
            </b-button>
            <b-button variant="danger" class="mb-4 mt-2 mr-2" @click="saveConfig" :disabled="serverRequesting">
              <i class="las la-save"/>
              Lưu lại
            </b-button>
          </template>
        </iq-card>
      </b-col>
      <b-col sm="6" v-for="(network) in networks" :key="network.id">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col sm="4"><h4 class="card-title">{{ network.name }}</h4></b-col>
              <b-col sm="2">
                <b-form-radio :name="`customRadio_network_${network.id}`" value="all" @change="changeAllGroupTo(network.id,'all')">
                  All
                </b-form-radio>
              </b-col>
              <b-col sm="6">
                <b-form-radio :name="`customRadio_network_${network.id}`" value="detail" @change="changeAllGroupTo(network.id,'detail')">
                  All type by type
                </b-form-radio>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="12">
                <ul class="pl-1">
                  <li v-for="acc in accountByNetworkId(network.id)" :key="acc.id">
                    <b-row>
                      <input type="hidden">
                      <b-col sm="4">{{ acc.username }}</b-col>
                      <b-col sm="2">
                        <b-form-radio v-model="submitData[acc.index].type" :name="`customRadio_${acc.index}`" value="all" @change="changeTo(acc.index, 'all')">
                          All
                        </b-form-radio>
                      </b-col>
                      <b-col sm="6">
                        <b-form-radio v-model="submitData[acc.index].type" :name="`customRadio_${acc.index}`" value="detail" @change="changeTo(acc.index, 'detail')">
                          All type by type
                        </b-form-radio>
                      </b-col>
                    </b-row>
                  </li>
                </ul>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import api from '../../store/api'

export default {
  name: 'AccountConfigList',
  components: {},
  async mounted () {
    findash.index()
    this.loadList()
    this.initData()
  },
  async created () {
  },
  watch: {
    account: function (newVal, oldVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  data () {
    return {
      submitData: []
    }
  },
  computed: {
    ...mapGetters({
      'networks': 'Network/listState',
      'account': 'Account/listState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    ...mapActions({
      'loadList': 'Account/loadList'
    }),
    initData: function () {
      this.submitData = _.map(this.account, (e, index) => {
        return Object.assign(e, {
          'index': index,
          'account': e.id,
          'type': e.show_type
        })
      })
    },
    accountByNetworkId: function (networkId) {
      return _.map(_.filter(this.submitData, (e) => {
        return e.network_id === networkId && e.parent_id === '0'
      }))
    },
    changeAllGroupTo: function (networkId, type) {
      _.each(this.submitData, (e, index) => {
        if (e.network_id === networkId && e.parent_id === '0') {
          this.submitData[index].type = type
        }
      })

      // force re-render accountByNetworkId
      this.$forceUpdate()
    },
    saveConfig: function () {
      let listIdAccount = _.map(this.submitData, (e) => {
        return e.id
      })
      let listType = _.map(this.submitData, (e) => {
        return e.type
      })

      api.account.accountConfig(listIdAccount, listType).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Lưu thành công'
        }).then(() => {
          this.loadList()
        })
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    changeTo (index, value) {
      this.submitData[index].type = value
    }
  }
}
</script>
